import WhyDoThisTooltip from './WhyDoThisTooltip';

export default WhyDoThisTooltip;
